import * as React from 'react';
import { Paper } from '@mui/material';

export const PreviewThumbnail = React.forwardRef<HTMLDivElement, any>((props, ref) => {
    const { url, style, ...rest } = props;
    return (
        <Paper
            ref={ref}
            style={Object.assign({}, style, {
                width: 60,
                height: 40,
                backgroundImage: `url(${url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                zIndex: 2
            })}
            {...rest}
        />
    );
});

PreviewThumbnail.displayName = 'PreviewThumbnail';
